<template>
  <div class="page-modify-mobile-by-sms">
    <form class="form"
          v-if="!showResetForm"
          @submit.prevent="handleVerifyMobile"
    >
      <div class="form-fields">
        <ym-field class="ym-field"
                  v-model.trim="mobile"
                  model="whole-line"
                  type="tel"
                  maxlength="11"
                  placeholder="输入原手机号"
                  :attr="{ autocomplete: false }"
        />
        <ym-field class="ym-field"
                  v-model.trim="smsCode"
                  model="whole-line"
                  placeholder="输入验证码"
                  maxlength="6"
                  :attr="{ autocomplete: false }"
                  @keyup.enter.prevent="handleVerifyMobile"
        >
          <template #button>
            <div class="sms-btn"
                 :class="{ 'disabled-btn': disabledSmsCode }"
                 @click.prevent="handleClickSendSmsCode"
            >
              {{ smsCodeText }}
            </div>
          </template>
        </ym-field>
      </div>
      <ym-button class="submit-btn"
                 size="large"
                 type="primary"
                 :disabled="disabledSubmitVerify"
                 @click.prevent="handleVerifyMobile"
      >下一步
      </ym-button>
      <div v-show="showTip"
           class="tip"
      >
        如原手机号码无法使用<br>
        请致电全国客服电话：<a class="link" :href="consumerHotLineHref">400-809-3885</a>
      </div>
    </form>
    <form class="form"
          v-if="showResetForm"
    >
      <div class="form-fields">
        <ym-field class="ym-field"
                  v-model.trim="newMobile"
                  model="whole-line"
                  type="tel"
                  maxlength="11"
                  placeholder="输入新的手机号码"
                  :attr="{ autocomplete: false }"
                  @keyup.enter.prevent="handleNewMobile"
                  @focusout.native="handleNewMobile"
        />
        <ym-field class="ym-field"
                  v-model.trim="newSmsCode"
                  model="whole-line"
                  placeholder="输入验证码"
                  maxlength="6"
                  :attr="{ autocomplete: false }"
                  @keyup.enter.prevent="handleVerifyMobile"
        >
          <template #button>
            <div class="sms-btn"
                 :class="{ 'disabled-btn': disabledNewSmsCode }"
                 @click.prevent="handleClickSendNewSmsCode"
            >
              {{ newSmsCodeText }}
            </div>
          </template>
        </ym-field>
      </div>
      <ym-button class="submit-btn"
                 size="large"
                 type="primary"
                 :disabled="disabledModifyMobile"
                 @click.prevent="handleModifyMobile"
      >
        确认
      </ym-button>
    </form>
  </div>
</template>

<script>
  import { Field, Button } from '@ymba/ym-ui';
  import validator from '@/utils/validator';
  import {
    sendSmsCode, verifyMobile, modifyMobileBySMS,
  } from '@/services/user';
  import { CONSUMER_HOTLINE, SMS_CODE_DURATION } from '@/utils/constant';
  import geetestMixin from '@/mixins/geetest/geetest';

  export default {
    name: 'PageModifyMobileBySMS',
    mixins: [geetestMixin],
    metaInfo: {
      title: '短信验证',
    },
    components: {
      'ym-field': Field,
      'ym-button': Button,
    },
    data() {
      return {
        smsType: 'sms_mobile_change',
        mobile: '',
        smsCode: '',
        smsCodeText: '获取验证码',
        smsCodeDisabled: true,
        duration: -1,
        submitVerifyDisabled: false,
        showResetForm: false,
        password: '',
        passwordCheck: '',
        resetPasswordDisabled: false,
        newMobile: '',
        newSmsCode: '',
        newSmsCodeText: '获取验证码',
        newSmsCodeDisabled: true,
        showTip: true,
      };
    },
    computed: {
      disabledSmsCode() {
        return this.mobile === '' || this.smsCodeDisabled;
      },
      disabledSubmitVerify() {
        return this.mobile === ''
          || this.smsCode === ''
          || this.submitVerifyDisabled;
      },

      disabledNewSmsCode() {
        return this.newMobile === '' || this.newSmsCodeDisabled;
      },
      disabledModifyMobile() {
        return this.newMobile === '' || this.newSmsCode === '';
      },
      consumerHotLineHref() {
        return `tel:${CONSUMER_HOTLINE}`;
      },
    },
    watch: {
      mobile(val) {
        if (this.smsCodeText.includes('已发送')) return;
        if (!validator.isMobile(val)) {
          this.smsCodeDisabled = true;
          return;
        }
        this.smsCodeDisabled = false;
      },
      newMobile(val) {
        if (this.newSmsCodeText.includes('已发送')) return;
        if (!validator.isMobile(val)) {
          this.newSmsCodeDisabled = true;
          return;
        }
        this.newSmsCodeDisabled = false;
      },
    },
    methods: {
      async handleVerifyMobile() {
        if (validator.isEmpty(this.smsCode)) {
          this.$toast('请填写验证码');
          return;
        }
        this.submitVerifyDisabled = true;
        try {
          await verifyMobile(this.mobile, this.smsCode, this.smsType);
          this.showResetForm = true;
        } catch (e) {
          this.showResetForm = false;
          this.submitVerifyDisabled = false;
        }
      },
      async handleClickSendSmsCode() {
        if (this.disabledSmsCode) return;
        this.verifyGeetest();
      },
      async handleClickSendNewSmsCode() {
        if (this.disabledNewSmsCode) return;
        this.verifyGeetest();
      },
      async onGeetestSuccess(geetestData) {
        if (this.showResetForm) {
          try {
            await sendSmsCode(this.newMobile, 'sms_bind', geetestData);
            this.newSmsCodeDisabled = true;
            let duration = SMS_CODE_DURATION;
            const t = setInterval(() => {
              if (duration <= 0) {
                this.newSmsCodeText = '重新获取';
                this.newSmsCodeDisabled = false;
                clearInterval(t);
                return;
              }
              this.newSmsCodeText = `已发送(${duration}s)`;
              duration -= 1;
            }, 1000);
          } catch (e) {
            this.newSmsCodeDisabled = false;
          }
          return;
        }
        try {
          await sendSmsCode(this.mobile, this.smsType, geetestData);
          this.smsCodeDisabled = true;
          this.duration = SMS_CODE_DURATION;
          const t = setInterval(() => {
            if (this.duration <= 0) {
              this.smsCodeText = '重新获取';
              this.smsCodeDisabled = false;
              clearInterval(t);
              return;
            }
            this.smsCodeText = `已发送(${this.duration}s)`;
            this.duration -= 1;
          }, 1000);
        } catch (e) {
          this.smsCodeDisabled = false;
        }
      },
      handleNewMobile() {
        if (!validator.isMobile(this.newMobile)) {
          this.$toast('请填写正确的手机号');
        }
      },
      async handleModifyMobile() {
        if (validator.isEmpty(this.newMobile)) {
          this.$toast('请填写新的手机号码');
          return;
        }
        if (validator.isEmpty(this.newSmsCode)) {
          this.$toast('请填写验证码');
          return;
        }
        try {
          await modifyMobileBySMS(this.newMobile, this.newSmsCode);
          this.$router.push({ name: 'ModifyMobile', query: { showNotify: true } });
        } catch (e) {
          this.resetPasswordDisabled = false;
        }
      },
      handleShowTip() {
        const pageHeight = document.body.scrollHeight;
        window.onresize = () => {
          this.showTip = document.body.scrollHeight >= pageHeight;
        };
      },
    },
    mounted() {
      this.handleShowTip();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-modify-mobile-by-sms {
    height: 100%;
    background-color: @color-white;
    padding: 0 @size-extra-medium;
    box-sizing: border-box;
  }

  /deep/ .old-mobile {
    input {
      color: @color-text-base;
    }
  }

  .ym-field {
    /deep/ .mint-field-other {
      display: flex;
      align-items: center;
    }
    /deep/ .ym-field-content-area {
      color: @color-black-dark;
      font-size: 46px;
      font-weight: @font-weight-bold;
      caret-color: #02cccc;
    }
    /deep/ ::placeholder {
      color: @color-gray-light;
      font-size: @font-size-medium;
      font-weight: @font-weight-primary;
    }
  }

  .sms-btn {
    color: #13b9bf;
    font-size: @font-size-medium;
    font-weight: @font-weight-bold;
    &.disabled-btn {
      opacity: 0.5;
    }
  }

  .submit-btn {
    border-radius: 25px;
    margin: 80px auto @size-medium;
    font-weight: @font-weight-bold;
    background-color: #02cccc;
    border: none;
    /deep/ &.is-disabled {
      background-color: #cccccc;
      opacity: 1;
      border: none;
    }
  }

  .tip {
    position: absolute;
    bottom: 63px;
    width: 87%;
    color: @color-text-light;
    font-size: 26px;
    line-height: 38px;
    text-align: center;
    .link {
      color: #576b95;
    }
  }
</style>
